import Key from "../../clientVariables.json";

export const fetchInlineEdit = async ({
  sectionName,
  currentContent,
  userPrompt,
  jobDescription,
}) => {
  const url = `${Key.domain.replace(/\/+$/, "")}/ai-search/inline-edit`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": Key.apiKey,
    },
    body: JSON.stringify({
      sectionName,
      currentContent,
      userPrompt,
      jobDescription: jobDescription || "",
    }),
  });

  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }

  if (!response.ok) {
    const message =
      body?.message || body?.error || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  if (!body?.success || body.updatedContent === undefined) {
    throw new Error(body?.message || "Invalid response from inline edit API");
  }

  return body.updatedContent;
};
